import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux/store";
import { NotificationTemplate } from "../../../../../redux/reducers/user-notifications.reducer";
import { GapContainer } from "../../../../../pages/components/card/styled";
import BarekamCheckbox from "../../../../../pages/components/checkbox";
import BarekamText from "../../../../../pages/components/text";
import { Message, MessageSections } from "../../../../../pages/components/message/message";
import notificationTemplateService from "../../../../../services/notification-template-service";
import { getNotificationTemplates } from "../../../../../redux/slices/user-notifications.slice";
import { User } from "../../../../../pages/shared/models/user/user";

const CustomerPersonalInfo = ({ customer }: { customer: User | undefined }) => {
    const [isReady, setIsReady] = useState<boolean>(false);

    const { statusNotificationTemplates, transactionNotificationTemplates } = useAppSelector(state => state.userNotificationsReducer);
    const [selectedStatusNotificationTemplates, setSelectedStatusNotificationTemplates] = useState<NotificationTemplate[]>([]);
    const [selectedTransactionNotificationTemplates, setSelectedTransactionNotificationTemplates] = useState<NotificationTemplate[]>([]);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (customer && customer.userId) {
            Promise.allSettled([
                notificationTemplateService.getNotificationConfigs(customer.userId),
                dispatch(getNotificationTemplates({ isConfigurable: true }))
            ]).then(([notificationConfigsResponse,]) => {
                const data = notificationConfigsResponse.status === 'fulfilled' ? notificationConfigsResponse['value'] : [];

                if (data && data.length) {
                    const statusTemplates = data.filter((template) => template.templateType === 1);
                    const transactionTemplates = data.filter((template) => template.templateType === 2);
                    setSelectedStatusNotificationTemplates(statusTemplates);
                    setSelectedTransactionNotificationTemplates(transactionTemplates);
                }

                setIsReady(true);
            })
        }
    }, []);

    const NotificationRow = (template: NotificationTemplate) => {
        const isChecked = template.templateType === 1 ? !!selectedStatusNotificationTemplates.find((selectedTemplate) => selectedTemplate.notificationTemplateId === template.notificationTemplateId) :
            !!selectedTransactionNotificationTemplates.find((selectedTemplate) => selectedTemplate.notificationTemplateId === template.notificationTemplateId);
        return (
            <GapContainer>
                <BarekamCheckbox checked={isChecked}
                    disabled />

                <BarekamText variant={'m'} opaque>
                    <Message messageKey={template.subject} sectionId={MessageSections.USER} />
                </BarekamText>
            </GapContainer>
        )
    }

    if (isReady) {
        return (
            <>
                {statusNotificationTemplates.templates.map(notificationData => {
                    return <NotificationRow notificationTemplateId={notificationData.notificationTemplateId}
                        subject={notificationData.subject}
                        body={notificationData.body}
                        section={notificationData.section}
                        templateType={1}
                        key={`status-${notificationData.notificationTemplateId}`} />
                })}
                {transactionNotificationTemplates.templates.map(notificationData => {
                    return <NotificationRow notificationTemplateId={notificationData.notificationTemplateId}
                        subject={notificationData.subject}
                        body={notificationData.body}
                        section={notificationData.section}
                        templateType={2}
                        key={`transaction-${notificationData.notificationTemplateId}`} />
                })}
            </>
        )
    } else {
        return <></>
    }
};

export default CustomerPersonalInfo;
